/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$( document ).ready(function() {
  $('#stickyMainPaymentContainer').closest('[data-section-id]').attr('class', '');
  $('#stickyMainPaymentContainer').closest('.pf-c').attr('class', '');
    $('#custom_rc_popup').hide();
  $('.custom-sticky-price').text($("[data-product-type=price]").text());
  
  var isVariantAvailable = $("input[name='sw-Size']:checked").attr('variant-available');
  // console.log(isVariantAvailable)
  if (isVariantAvailable == 'false')
	{
	  $('#customAddToCart').prop('disabled', true);
	  $('.sticky-add-to-cart-text').text('Sold Out');
	}
  
    $('.pf-vs-label').click(function(){
  var variantPrice = $("[data-product-type=price]").text();
	  isVariantAvailable = $("input[name='sw-Size']:checked").attr('variant-available');

  if (isVariantAvailable == 'false')
	{
	  $('#customAddToCart').prop('disabled', true);
	  $('.sticky-add-to-cart-text').text('Sold Out');
	}
	  else
		{
		  $('#customAddToCart').prop('disabled', false);
		  $('.sticky-add-to-cart-text').text('Add to cart');
		}
   // $('.custom-sticky-price').text(variantPrice);
});

  $('.pf-option-swatches input').click(function(){
  setTimeout(
  function() 
  {
    if( $("[data-checkout=cart]").prop('disabled') )
   {
     $('#customAddToCart').prop('disabled', true);
	  $('.sticky-add-to-cart-text').text('Sold Out');
   }
    else
  {
      $('#customAddToCart').prop('disabled', false);
	  $('.sticky-add-to-cart-text').text('Add to cart');
  }
    
  }, 500);
   
});
  
  $('[data-product-type=price]').on('DOMSubtreeModified',function(){
  $('.custom-sticky-price').text($(this).text());
})
  $('#customAddToCart').click(function(e){
       e.preventDefault();
       console.log('hello');
       $(this).find('span').addClass('hide');
       $(this).append("<div class='custom_loader'></div>");
       $("[data-checkout=cart]").click();
        setTimeout(
        function() 
        {
          $('#customAddToCart').find('span').removeClass('hide');
          $(".custom_loader").remove(); 
        }, 3000);
});
  $(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 800) {
    $('#stickyMainPaymentContainer').fadeIn().css("display","grid");
  } else {
    $('#stickyMainPaymentContainer').fadeOut();
  }
});

  
  
  });



    $(document).ready(function () {
        $(".collapsible__btn").click(function () {
            $(".collapsible__text_inside").slideToggle(350);
        });

        $('.main-block-js input').on('change', function(e) {
          e.preventDefault();
      // alert( this.value );
        var mainProductVariant = $(this).attr('Id');
          var dataBindValue = $(this).attr('data-custom-selector');
         // console.log($("input[data-custom-selector='"+dataBindValue+"']" ));
          $("input[data-custom-selector='"+dataBindValue+"']" ).prop('checked', true);

          $('#custom_sticky_' + mainProductVariant).prop('checked', true).change();
    });

      $('.main-block-js input').on('click', function(e) {
        
      $(this).attr('checked',true);
      });
  
      $('.sticky-block-js input').on('change', function(e) {
       // alert( this.value );
        e.preventDefault();
        var mainProductVariant = $(this).attr('pId');
        var variantId = $(this).attr('variant_id');
        console.log(variantId, 'variantId')
        var variantP = $(this).attr('variant_P');
        console.log(variantP, 'variantP')
        var variant_CP = $(this).attr('variant_CP');
        console.log(variant_CP, 'variant_CP')
        $('#' + mainProductVariant).prop('checked', true);
        $('.variant___price').text(variantP);$('.compare___price').text(variant_CP);
        $('.shopify-product-form').find('input[name="id"]').val(variantId);

        // var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
        // window.history.replaceState({path: newurl}, '', newurl);
        // console.log(newurl)
        
        // $('#' + mainProductVariant).next('label').trigger( "click" );
    });

    $('.variant___price').on('DOMSubtreeModified',function(){
    $('.sticky-price').text($(this).text());
})
      
      
    });

if (window.matchMedia('(max-width: 767px)').matches) {
        $(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 1150) {
    $('#custom-sticky-btn').fadeIn(500).css("display","grid");
  } else {
    $('#custom-sticky-btn').fadeOut(500);
  }
});
    } else {
        $(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 700) {
    $('#custom-sticky-btn').fadeIn(500).css("display","grid");
  } else {
    $('#custom-sticky-btn').fadeOut(500);
  }
});
    }

$(document).ready(function () {
  function getFormattedDate(date) {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let day = date.getDate();
    let month = monthNames[date.getMonth()];

    return `${month} ${day}`;
  }

  function addDaysToDate(date, daysToAdd) {
    let newDate = new Date(date);
    newDate.setDate(date.getDate() + daysToAdd);

    return newDate;
  }

  let todaysDate = new Date();
  let nexttwodaysdate = addDaysToDate(
    todaysDate,
    parseInt($(".deliverydate").attr("estimated-date"))
  );

  $(".deliverydate").text(" " + getFormattedDate(nexttwodaysdate));
});


// For Tracking Page

$(document).ready(function () {
  $(".byorderNumber").addClass("active_border");
  // $(".byorderNumber").click(function(){
  //   $("#order_active").slideDown("slow");
  //   $("#tracking_active").slideUp("slow");
  //   $(this).addClass('active_border');
  //   $(".bytrackingNumber").removeClass('active_border');
  // });
  // $(".bytrackingNumber").click(function(){
  //   $("#order_active").slideUp("slow");
  //   $("#tracking_active").slideDown("slow");
  //   $("#tracking_active").slideDown("slow");
  //   $(this).addClass('active_border');
  //   $(".byorderNumber").removeClass('active_border');
  // });

  $(document).on("click", ".pp_tracking_tab_left:first", function () {
    console.log("clicked");
    $(".pp_tracking_form_order").show();
    $(".pp_tracking_form_number").hide();
    $(this).addClass("active_border");
    $(".pp_tracking_form_number").removeClass("active_border");
  });
  $(document).on("click", ".pp_tracking_tab_left:nth-child(2)", function () {
    console.log("clicked2");
    $(".pp_tracking_form_number").show();
    $(".pp_tracking_form_order").hide();
    $(this).addClass("active_border");
    $(".byorderNumber").removeClass("active_border");
  });

  var interval;
  interval = setInterval(function () {
    if ($(".pp_tracking_content").length > 0) {
      // $('.pp_tracking_title').addClass('hide');
      // let radioParentDiv = `<div class="order_by">
      //     <p class="byorderNumber active_border">Order Number</p>
      //     <p class="bytrackingNumber">Tracking Number</p>
      //   </div>`
      $(".pp_tracking_tab")
        .find(".pp_tracking_tab_left:first")
        .addClass("byorderNumber active_border");
      $(".pp_tracking_tab")
        .find(".pp_tracking_tab_left:nth-child(2)")
        .addClass("bytrackingNumber");

      clearInterval(interval);
    }
  }, 500);

  $(document).on("click", ".pp_tracking_button", function (e) {
    console.log("clicked");
    var interval;
    interval = setInterval(function () {
      if ($(".pp_num_status_show").length > 0) {
        $(".t_order_sections_top").addClass("results--Found");

        clearInterval(interval);
      }
    }, 500);
  });

  //  $(document).on('change', 'input#orderNumber', function() {
  //    $('input.PP-TextField__Input[name="order"]').val($(this).val());
  //  });
  // $(document).on('change', 'input#orderEmail', function() {
  //    $('input.PP-TextField__Input[name="email"]').val($(this).val());
  //  });
  // $(document).on('change', 'input#trackingNumber', function() {
  //    // $('input.PP-TextField__Input[name="nums"]').val($(this).val()).trigger("change");
  //    $('input.PP-TextField__Input[name="nums"]').focus().val($(this).val());
  //  });

  // $(document).on('change', 'input[name="nums"]', function() {
  //   alert($('input.PP-TextField__Input[name="nums"]').val())
  // });

  // $(document).on('click', '.order_track_button', function() {

  //   $('button.pp-button-enter').click();

  // });
});



  
$(document).ready(function () {
  if (window.location.href.indexOf("?nums") > -1) {
    // alert('clicked');
    var interval;
    interval = setInterval(function () {
      if ($(".pp_num_status_show").length > 0) {
        $(".t_order_sections_top").addClass("results--Found");

        clearInterval(interval);
      }
    }, 500);
  }

  $(".pp-button-enter").click(function () {
    $(".t_order_sec_form").addClass("heightremove");
  });
});

// End Tracking page

// Pasted from product-form-2
$(document).ready(function(){
  let varBtn = document.querySelectorAll(".block-swatch__item__cusotm");
  let varPrice = document.querySelectorAll(".theme-money.large-title");
  let varCompPrice = document.querySelectorAll(".product-price__compare");
  let prc = document.querySelectorAll(".product__variant__price");
  let compPrc = document.querySelectorAll(".product__variant__compare_price");
  
  for(let i=0; i<varBtn.length; i++){
    varBtn[i].addEventListener("click", function(){
      
      document.querySelector(".variant___price").innerHTML = varPrice[i].innerHTML;
      if(document.querySelector(".compare___price")){
        document.querySelector(".compare___price").innerHTML = varCompPrice[i].innerHTML;        
      }
      let varCompPRC = Number(compPrc[i].innerHTML);
      let varPRC = Number(prc[i].innerHTML);
      let sparePrc = ((varCompPRC - varPRC) / varCompPRC) * 100;
      if(document.querySelector(".spare__amount")){
        document.querySelector(".spare__amount").innerHTML = `SAVE ${Math.round(sparePrc)}%`;        
      }
      
    })
  }
  
    $(".included__meta").on("click", function(){
      $(".included__overlay").addClass("pushbar_open").slide("slow");
    })
    // If an event gets to the body
    $(".included__overlay").click(function(){
      $(".included__overlay").removeClass("pushbar_open").slide("slow");
    });

    $(".included__close").click(function(){
      $(".included__overlay").removeClass("pushbar_open").slide("slow");
    });
    
    // Prevent events from getting pass .popup
    $(".included__drawer").click(function(e){
      e.stopPropagation();
    });
  });


$(document).ready(function(){

    function isInViewport(theDiv) {
    let elementTop = theDiv.offset().top;
    let elementBottom = elementTop + theDiv.outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + window.innerHeight;
    return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    var animationDone = false;
    if ($('#product-block-tested').length) {
    $(window).on('scroll', function(){
      if (!animationDone) {
      if(isInViewport($('#product-block-tested'))) {
        animationDone = true;
        $(".circleBarProgress").each(function () {
          var t = $(this).find(".circleBar"),
              i = $(this).find("span"),
              e = parseInt(i.text(), 10);
          $({ p: 0 }).animate(
              { p: e },
              {
                  duration: 3e3,
                  easing: "swing",
                  step: function (e) {
                      t.css({ transform: "rotate(" + (45 + 1.8 * e) + "deg)" }), i.text(0 | e);
                      
                  },
              }
          );
        });
      }
    }
    });
    }
    });


//collapsible-content

$(document).ready(function() {
    $(".collapsible_rb .collapsible2__button").click(function() {
        var content = $(this).siblings(".collapsible_rb .collapsible2__content");
        
        if (content.css("max-height") === "0px") {
            content.css("max-height", content.prop("scrollHeight") + "px");
        } else {
            content.css("max-height", "0px");
        }

      $(this).parents('.collapsible2').siblings().find('.collapsible2__content').css("max-height", "0px");
        
        $(this).toggleClass("content--active");
         $(this).parents('.collapsible2').siblings().find('.collapsible2__button').removeClass("content--active");
       $(this).parents('.collapsible2').toggleClass("active");
      $(this).parents('.collapsible2').siblings().removeClass("active");
    });
});

$(document).ready(function(){
   $(document).on("click", ".subscription-radio", function () {
    $(this).parents('body').find('square-placement').addClass('hide');   
  });

    $(document).on("click", ".onetime-radio", function () {
    $(this).parents('body').find('square-placement').removeClass('hide'); 
      $('square-placement').show();
  });

  
   $('square-placement').addClass('hide');   

  
var intervalHide = setInterval(function () {
  if (window.location.href.indexOf("selling_plan") > -1) {
    $('square-placement').hide();  
    clearInterval(intervalHide);
  }
 }, 500);
});


  $(document).on('click', '.upsell-btn-js', function(e){
       e.preventDefault();
    $this = $(this);
    $this.find('span.add-text').hide();
    $this.append("<div class='custom_loader'></div>");
     let upsellId = $(this).attr('variant__id');
       if (upsellId) {
         $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: upsellId
          },
            dataType: 'json', 
           success: function (data) { 
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                 bubbles: true,
                detail: {
              cart: data,
              openMiniCart: false
            }
                }));
              jQuery.getJSON('/cart.js', function(cart) {
              jQuery("cart-count").html(cart.item_count);
           });
             // document.dispatchEvent(new CustomEvent('cart:updated', {
             //     bubbles: true
             //    }));

        setTimeout(
        function() 
        {
          $this.find('span.added-text').fadeIn();
          $this.removeClass('upsell-btn-js');
          $(".custom_loader").remove(); 
        }, 2000);
           }
     });
       }  

});

$("#upsell-switch").change(function(e) {
    if(this.checked) {
        e.preventDefault();
     let upsellId = $(this).attr('variant__id');
       if (upsellId) {
         $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: upsellId
          },
            dataType: 'json', 
           success: function (data) { 
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                 bubbles: true,
                detail: {
              cart: data,
              openMiniCart: false
            }
                }));
              jQuery.getJSON('/cart.js', function(cart) {
              jQuery("cart-count").html(cart.item_count);
           });
             document.dispatchEvent(new CustomEvent('cart:updated', {
                 bubbles: true
                }));

           }
     });
       }  
    }
  else
    {
       e.preventDefault();
     let upsellId = $(this).attr('variant__id');
       if (upsellId) {
         $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: upsellId
          },
            dataType: 'json', 
           success: function (data) { 
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                 bubbles: true,
                detail: {
              cart: data,
              openMiniCart: false
            }
                }));
              jQuery.getJSON('/cart.js', function(cart) {
              jQuery("cart-count").html(cart.item_count);
           });
             document.dispatchEvent(new CustomEvent('cart:updated', {
                 bubbles: true
                }));

           }
     });
       }  
    }
});

 
// 13/11/2024 start

$(document).ready(function() {
  // Function to update prices and savings
  function updatePrices() {
    var selectedRadio = $('input[type="radio"]:checked');
    var savingValue = selectedRadio.data('saving');

    if (!savingValue) {
      var bundlePrice = selectedRadio.data('bundle-price');
      var comparePrice = selectedRadio.data('bundlecompare-price');
      if (bundlePrice && comparePrice) {
        var priceDifference = comparePrice - bundlePrice;
        savingValue = ((priceDifference / comparePrice) * 100).toFixed(2);
      }
    }

    var bundlePrice = selectedRadio.data('bundle-price');
    var comparePrice = selectedRadio.data('bundlecompare-price');
    $('.price_wrapper .regualer_price').text(bundlePrice);
    $('.price_wrapper .compare-price').text(comparePrice);

    if (savingValue) {
      $('.label-list .saving-value').text(savingValue + '%');
    }
  }

  updatePrices();

  $('input[type="radio"]').on('change', function() {
    updatePrices();
  });
  });


// Section-Collapsible_tab

  function toggleTab(tabIndex) {
    var tabContent = document.querySelectorAll(".tab-content")[tabIndex-1];
    var tabHeader = document.querySelectorAll(".tab-header")[tabIndex-1];

    if (tabContent.style.display === "block") {
      tabContent.style.display = "none";
      tabHeader.classList.remove("active");
    } else {
      tabContent.style.display = "block";
      tabHeader.classList.add("active");
    }
  }



// Section-comparision-slider-with-text

if (document.getElementById("cst_comparison")) {
  var divisor = document.getElementById("cst_divisor"),
      handle = document.getElementById("cst_handle"),
      slider = document.getElementById("cst_slider");

  function moveDivisor() {
    handle.style.left = slider.value + "%";
    divisor.style.width = slider.value + "%";
  }

  window.onload = function() {
    moveDivisor();
  };
}







